import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(() => ({
  paginationNumberedButtonsChild: {
    fontSize: '16px',
    display: 'flex',
    paddingTop: '4px',
    color: '#262A4C',
    flexShrink: 0, // IMPORTANT: prevents squishing/shrinking
  },

  paginationDottedButtons: {
    display: 'flex',
    justifyContent: 'center',
    columnGap: '10px',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    paddingBottom: '3px',
  },

  paginationMainGrid: {
    display: 'flex',
    width: 'max-content',
    height: 'max-content',
    color: 'grey',
    alignItems: 'center',
    paddingTop: '16px',
    marginTop: 'auto',
    justifyContent: 'center',
  },

  ArrowBackIosIcon: {
    cursor: 'pointer',
    width: '30px',
    padding: '5px',
    paddingBottom: '5px',
    paddingRight: '0px',
    color: (props) => (props.resultsPageOffset === 0 ? 'grey' : '#262A4C'),
  },

  ArrowForwardIosIcon: {
    cursor: 'pointer',
    width: '30px',
    padding: '5px',
    paddingBottom: '5px',
    color: (props) =>
      props.resultPagesArray.length - 1 ===
      props.resultsPageOffset / props.resultPageLimit
        ? 'grey'
        : '#262A4C',
  },

  paginationStyle: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '&:hover': {
      color: '#00B7A4',
    },
  },
}))

export { styles }
